import { Component } from '@angular/core';

@Component({
  selector: 'lib-shared',
  imports: [],
  templateUrl: './shared.html',
  styleUrl: './shared.scss',
})
export class Shared {}
